export const PlanPurchaseExperienceMainContentMinWidth = 400
export const PlanPurchaseExperienceMainContentMaxWidth = 596
export const PlanPurchaseExperiencePromoContentFullWidth = 376

export const PlanPurchaseExperienceNarrowFieldMaxWidth = 448

export const CLIENT_SIDE_STRIPE_ERROR = 'StripePaymentFailedError'
export const CLIENT_SIDE_STRIPE_PAYMENT_INTENT_LAST_PAYMENT_ERROR = 'PaymentIntentLastPaymentError'
export const CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR = 'PaymentIntentStatusError'
